import React from "react";
import { message, Button, Col, Form, Icon, Input, Row, Select } from "antd";
import img from "../../assets/img/At the office-pana 1.png";
import MiCompAPI from "../../util/api";

const { Option } = Select;
class FD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      EventField: [],
      SRTemplates: [],
      title: this.props.eEvent ? "Update Event" : "Add Event",
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let { eEvent } = this.props;

        this.props.submitHandler({
          ...values,
          eventId: eEvent ? eEvent.eventId : 0,
        });
      }
    });
  };

  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            EventField: data.eventtype,
          });
        }
      },
      ["EventType"]
    );
  }
  componentDidMount() {
    this.getClientMasters();
    this.GetAllSRTemplate();
    let { eEvent } = this.props;
    const { setFieldsValue } = this.props.form;
    if (eEvent) {
      setFieldsValue({
        eventName: eEvent.eventName,
        moduleName: eEvent.moduleName,
        eventTypeID: eEvent.eventTypeID,
        eventDescription: eEvent.eventDescription,
        templateId: eEvent.templateId,
      });
    }
  }
  GetAllSRTemplate() {
    this.api.invoke("GetAllSRTemplate", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            allFieldsLoading: false,
            SRTemplates: data.data.templates,
          });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p style={{ marginLeft: "14px" }} className="mi_title">
              {this.state.title}
            </p>
          </Col>
          <Col span={6}>
            <i
              className="fa fa-times mi_icon mi_icon_red mi_button_close"
              style={{ color: "red" }}
              onClick={this.props.closeDrawerHandler}
            ></i>
          </Col>
        </Row>

        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Event Name</legend>
                  {getFieldDecorator("eventName", {
                    rules: [
                      { required: true, message: "Please Enter event name" },
                    ],
                  })(
                    <Input
                      className="mi_input"
                      maxLength={40}
                      type="text"
                      placeholder="Please Enter Event Name *"
                    />
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Module Name</legend>
                  {getFieldDecorator("moduleName", {
                    rules: [
                      { required: true, message: "Please Enter module name" },
                    ],
                  })(
                    <Input
                      type="text"
                      style={{ height: "100px" }}
                      autoComplete={"nope"}
                      className="mi_input"
                      placeholder="Enter Module Name *"
                    />
                  )}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Event Type</legend>
                  {getFieldDecorator("eventTypeID", {
                    rules: [
                      {
                        required: true,
                        message: (
                          <span style={{ marginTop: "-6px !important" }}>
                            {" "}
                            Please Select EventType.{" "}
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Select
                      suffixIcon={
                        <Icon
                          style={{ transform: "rotate(90deg)" }}
                          type="double-right"
                        />
                      }
                      className="mi_input"
                      optionFilterProp="children"
                      placeholder=" Please Select EventType *"
                    >
                      {this.state.EventField.map((tag) => (
                        <Option value={tag.id} key={tag.id}>
                          {tag.code}
                        </Option>
                      ))}
                    </Select>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Event Description</legend>
                  {getFieldDecorator("eventDescription", {
                    rules: [
                      {
                        required: true,
                        message: "Please Enter Event Description",
                      },
                    ],
                  })(
                    <Input
                      type="text"
                      style={{ height: "100px" }}
                      autoComplete={"nope"}
                      className="mi_input"
                      placeholder="Enter Event Description *"
                    />
                  )}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font"> Template </legend>
                  {getFieldDecorator("templateId", {
                    rules: [
                      {
                        required: true,
                        message: (
                          <span style={{ marginTop: "-6px !important" }}>
                            {" "}
                            Please Select Template.{" "}
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Select
                      suffixIcon={
                        <Icon
                          style={{ transform: "rotate(90deg)" }}
                          type="double-right"
                        />
                      }
                      className="mi_input"
                      optionFilterProp="children"
                      placeholder="Please Select Template *"
                    >
                      {this.state.SRTemplates.map((tag) => (
                        <Option value={tag.templateId} key={tag.templateId}>
                          {tag.template_Name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: "30px" }}>
            <Col span={7}></Col>

            <Col span={5}>
              <Button
                className="mi_button_right submit-button"
                onClick={this.props.closeDrawerHandler}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
            </Col>
            <Col span={5}>
              <Button
                htmlType="submit"
                className="submit-button"
                type="primary"
              >
                Submit
              </Button>
            </Col>
            <Col span={7}>
              <img
                alt="example"
                style={{
                  height: "70px",
                  marginBottom: "-30px",
                  float: "right",
                }}
                src={img}
              />
            </Col>
            <Col span={7}></Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const AddEvent = Form.create()(FD);
export default AddEvent;
